/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  InfoOverlay component
 */
/** @jsx jsx */

import { Box } from '@chakra-ui/react'
import { jsx } from '@emotion/react'
import { useBodyColor } from '@zcode-ui/chakra-themes'
import { Z_INDEX_GROUP_1 } from '@zcode-ui/themes'
import type { Listable } from '@zcode/state-type'
import { getShowAmenitiesOrDescription } from '../../helpers/getShowAmenitiesOrDescription'
import { HeaderAndLocationContainer } from '../HeaderAndLocation/HeaderAndLocationContainer'
import { InfoOverlayContentContainer } from '../InfoOverlayContent/InfoOverlayContentContainer'

export interface Props {
  entity: Listable
  isBot: boolean
  isCFR?: boolean
  isLargeCard?: boolean
  isMobile: boolean
  showInfo: boolean
}

const InfoOverlay = ({ entity, isCFR, isLargeCard, showInfo, isMobile }: Props) => {
  const { bgColor, textColor } = useBodyColor()
  const { showShortDescription } = getShowAmenitiesOrDescription({ isCFR, listable: entity })

  return (
    <Box<'div'>
      aria-hidden={!showInfo}
      bg={bgColor}
      color={textColor}
      display={showInfo ? 'block' : 'none'}
      height={showShortDescription ? '100%' : 'calc(100% - 10px)'}
      zIndex={showInfo ? Z_INDEX_GROUP_1 : -1}
    >
      <Box<'div'>
        bg={bgColor}
        display="flex"
        flexDir="column"
        height="calc(100% - 10px)"
        maxWidth="340px"
      >
        <HeaderAndLocationContainer
          aria-hidden={!showInfo}
          entity={entity}
          isBuilding={entity?.isBuilding}
          isLargeCard={isLargeCard}
          isOverlay
        />
        <InfoOverlayContentContainer
          isLargeCard={isLargeCard}
          isMobile={isMobile}
          listable={entity}
        />
      </Box>
    </Box>
  )
}

export { InfoOverlay }
